<template>
  <div>
    <section class="hero is-medium is-primary is-bold">
      <div class="hero-body">
        <router-link class="title" to="/leagues">Leagues</router-link>
      </div>
    </section>
    <section class="hero is-medium is-primary is-bold">
      <div class="hero-body">
        <router-link class="title" to="/tournaments">Tournaments</router-link>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>
